import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_11189_29939",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "24",
      height: "24"
    }, [
      _createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_11189_29939)" }, [
      _createElementVNode("path", {
        d: "M13.6923 17.3079L12.9845 16.5886L17.073 12.5001H5V11.5001H17.073L12.9845 7.41163L13.6923 6.69238L19 12.0001L13.6923 17.3079Z",
        fill: "white"
      })
    ], -1)
  ])))
}
export default { render: render }